import { Tooltip, Typography } from '@mui/material'
import { GridCellParams } from '@mui/x-data-grid-pro'

import { getFormattedDateTime } from '../../../../utils/helpers'
import useSharedStyles from '../../../../utils/shared.styles'

const AlertsTableEnterExitTime = (cellParams: GridCellParams<DeviceAlertTableRow, DeviceAlertTableRow['entryTime'] | DeviceAlertTableRow['exitTime']>) => {
  const classes = useSharedStyles
  const cellValue = cellParams.value

  if (!cellValue) return <div>-</div>

  return (
    <div style={{ width: '100%' }}>
      <Tooltip
        title={
          <>
            {getFormattedDateTime(cellValue, 'UTC', 'LLL. d, yyyy')}
            <br />
            {getFormattedDateTime(cellValue, 'UTC', "h:mm aa 'UTC'")}
          </>
        }
      >
        <Typography variant="body2" sx={classes.overflowText}>
          {getFormattedDateTime(cellValue, 'UTC', 'LLL. d, yyyy')}
          <br />
          {getFormattedDateTime(cellValue, 'UTC', "h:mm aa 'UTC'")}
        </Typography>
      </Tooltip>
    </div>
  )
}

export default AlertsTableEnterExitTime
